<template>
    <div class="module__show">
        <div class="module__show_header">
            <view-actions
                :title="`Module: ${moduleName}`"
                :notify-title="'module'"
                :notify-process="'stop showing'"
                :cancel-button-text="'Go back'"
                :cancel-notify-active="false"
                :breadcrumb-active="true"
                :breadcrumb-items="[
                    {
                        name: 'Modules',
                        to: { name: 'ebs-module-list' }
                    }
                ]"
                :submit-button-active="user.isCourseCreator()"
                :submit-button-text="moduleIsDraftVersion ? 'Edit draft' : 'Edit module'"
                @emit-cancel="moduleStopShow"
                @emit-submit="moduleEdit"
            />
        </div>
        <div class="module__show_main">
            <div class="container fullheight">
                <div class="columns is-block-mobile fullheight m-t-b-0">
                    <div class="column is-narrow p-t-b-0">
                        <component-sidebar :nav-items="[
                            { label: 'Content', name: 'ebs-module-show-content', visible: () => true },
                            { label: 'Details', name: 'ebs-module-show-details', visible: () => true },
                            { label: 'Versions', name: 'ebs-module-show-versions', visible: () => true }
                        ]"></component-sidebar>
                    </div>
                    <div class="column p-t-b-0">
                        <section class="module__show_main_content">
                            <div class="module__show_main_content_versioninfo">
                                {{ moduleLatestVersionNumber ? `Version ${moduleLatestVersionNumber} released ${moduleLatestVersionDate}` : 'Not released yet.' }}
                            </div>
                            <keep-alive>
                                <transition name="fade" mode="out-in">
                                    <router-view/>
                                </transition>
                            </keep-alive>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import { User } from '@/User'
import ComponentText from '@/components/default/shared/ComponentText'
import { toLocaleDateTime, toLocaleTime } from '@/functions'
import ComponentSidebar from '@/components/default/shared/ComponentSidebar'

export default {
  name: 'module-show',
  components: { ComponentSidebar, ComponentText, ViewActions },
  data () {
    return {
      user: new User()
    }
  },
  computed: {
    moduleName () {
      return this.$store.getters.getEbsModuleName
    },
    moduleIsDraftVersion () {
      return Boolean(this.$store.getters.getEbsModuleDraft)
    },
    moduleLatestVersionNumber () {
      return this.$store.getters.getEbsModuleLatestVersionNumber
    },
    moduleLatestVersionDate () {
      const latestVersionDate = this.$store.getters.getEbsModuleLatestVersionDate
      return toLocaleDateTime(latestVersionDate) + ' ' + toLocaleTime(latestVersionDate)
    }
  },
  methods: {
    allowRedirectBeforeRouteLeave () {
      this.$eventBus.$emit('module-submit')
    },
    //
    moduleStopShow () {
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'ebs-module-list' })
    },
    moduleEdit () {
      const moduleId = this.$route.params.id
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'ebs-module-edit', params: { id: moduleId } })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/modules/moduleaddedit";
</style>
